<template>
  <div class="rule-wrapper">
    <div class="title">数据说明</div>
    <slot name="regular">
      <pre>
下载次数：地图作品被玩家下载的累计次数
浏览次数：地图作品详情页（工坊或大厅内）被玩家查看的累计次数
游玩次数：地图作品被玩家进入游玩累计次数
游玩时长：地图作品被玩家进入停留游玩的累计时长
评论数：地图作品被玩家评论的累计次数
投块数：地图作品获得投块的累计数
点赞数：地图作品获得玩家点赞的累计次数
收藏数：地图作品被玩家收藏的累计次数
广告收益：玩家观看作品内的广告后产生的收益；
广告展示：地图作品内的玩家点击播放广告的次数；
贡献点：玩家使用迷你币消费您的作品或道具；
迷你点：玩家使用迷你点购买了作品或资源
迷你豆：玩家使用迷你豆购买了作品或资源；
      </pre>
    </slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.rule-wrapper {
  padding: 20px 32px;
  line-height: 40px;

  .title {
    padding: 20px 0;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  }

  > p {
    padding-bottom: 20px;
    font-size: 26px;
  }
}
</style>
